import {
  RESET_NAV_BAR,
  SET_HIDE_NAV_LINKS,
  SET_SHOW_CHECKOUT_TRANSFER_MODAL,
  TOGGLE_NAV_HEADER,
} from 'src/app/state/actions/types';

export function toggleHideHeader(hideNavBar) {
  return {
    type: TOGGLE_NAV_HEADER,
    hideNavBar,
  };
}

export function toggleHideNavLinks() {
  return {
    type: SET_HIDE_NAV_LINKS,
  };
}

export function resetNavBar() {
  return { type: RESET_NAV_BAR };
}

export const setShowCheckoutTransferModal = show => ({
  type: SET_SHOW_CHECKOUT_TRANSFER_MODAL,
  show,
});
